export default __webpack_public_path__ + "static/media/04.e4bd50ad.jpg";